import React, { useRef } from "react";
import { getDefaultAvatar } from '../utils/avatarUtils';

function ProfileAvatar({ avatarUrl, onEdit, size = "large", className = "" }) {
  const fileInput = useRef();

  // Size variants
  const sizeClasses = {
    small: {
      width: 32,
      height: 32,
      maxWidth: "32px",
      maxHeight: "32px",
      borderRadius: "8px",
      border: "2px solid #dde6ef"
    },
    medium: {
      width: 48,
      height: 48,
      maxWidth: "48px", 
      maxHeight: "48px",
      borderRadius: "12px",
      border: "2px solid #dde6ef"
    },
    large: {
      width: 120,
      height: 120,
      maxWidth: "120px",
      maxHeight: "120px", 
      borderRadius: "50%",
      border: "2px solid #dde6ef"
    },
    navbar: {
      width: 36,
      height: 36,
      maxWidth: "36px",
      maxHeight: "36px",
      borderRadius: "8px",
      border: "2px solid #dde6ef"
    }
  };

  const avatarStyles = sizeClasses[size] || sizeClasses.large;
  const isSmallSize = size === "small" || size === "navbar";
  const showEditOverlay = onEdit && !isSmallSize;

  return (
    <div
      className={`profile-avatar-wrapper ${className}`}
      tabIndex={onEdit ? 0 : -1}
      role={onEdit ? "button" : "img"}
      aria-label={onEdit ? "Change profile picture" : "Profile picture"}
      style={{
        position: "relative",
        display: "inline-block",
        cursor: onEdit ? "pointer" : "default",
        outline: "none",
        ...(size === "large" && { marginBottom: 18 })
      }}
      onClick={() => onEdit && onEdit()}
      onKeyDown={e => onEdit && (e.key === "Enter" || e.key === " ") && onEdit()}
    >
      <img
        src={avatarUrl || getDefaultAvatar()}
        alt="Profile avatar"
        className={`avatar avatar-${size}`}
        style={{
          ...avatarStyles,
          objectFit: "cover",
          background: "#fafbfc",
          transition: "all 0.2s ease"
        }}
        onError={e => { 
          e.target.onerror = null; 
          e.target.src = getDefaultAvatar(); 
        }}
      />
      
      {/* Edit overlay - only show on large avatars */}
      {showEditOverlay && (
        <div 
          className="avatar-edit-overlay"
          style={{
            position: "absolute",
            left: 0,
            bottom: 6,
            width: "100%",
            textAlign: "center",
            fontSize: 14,
            color: "#338",
            background: "rgba(255,255,255,0.95)",
            borderRadius: size === "large" ? "0 0 60px 60px" : "0 0 12px 12px",
            pointerEvents: "none",
            fontWeight: 500,
            marginTop: 8,
            padding: "4px 0"
          }}
        >
          Edit
        </div>
      )}
    </div>
  );
}

export default ProfileAvatar;